import api from '@/api';
import Invite from '@/models/core/Invite';
import Context from '@/models/Context';
import Team from '@/models/core/Team';
import authenticator from '@/authenticator/token';
import moment from 'moment';

const state = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  isFetched: false
};

const getters = {
  isLoading(state) {
    return state.isLoading;
  },

  isUpdating(state) {
    return state.isUpdating;
  },

  isDeleting(state) {
    return state.isDeleting;
  },

  isFetched(state) {
    return state.isFetched;
  }
};

const mutations = {
  setLoading(state, value) {
    state.isLoading = value;
  },

  setUpdating(state, value) {
    state.isUpdating = value;
  },

  setDeleting(state, value) {
    state.isDeleting = value;
  },

  setFetched(state, value) {
    state.isFetched = value;
  }
};

const actions = {
  reset({ commit }) {
    commit('setLoading', false);
    commit('setUpdating', false);
    commit('setDeleting', false);
    commit('setFetched', false);
  },

  findForTeam({ commit, dispatch, state }) {
    if (!state.isFetched) {
      const domain = Context.query().first().domain;

      commit('setLoading', true);
      api.get(`/${domain}/invites`).then(response => {
        dispatch(
          'normalize',
          {
            model: Invite,
            data: response.data.data
          },
          { root: true }
        ).then(() => {
          commit('setLoading', false);
          commit('setFetched', true);
        });
      });
    }
  },

  findByToken({ commit, dispatch }, token) {
    commit('setLoading', true);
    api.get(`/invite-token/${token}`).then(response => {
      response.data.data.token = token;
      dispatch(
        'normalize',
        { model: Invite, data: response.data.data },
        { root: true }
      ).then(() => {
        commit('setLoading', false);
      });
    });
  },

  create({ commit, dispatch }, newObject) {
    const domain = Context.query().first().domain;
    const groups = newObject.groups.map(group => {
      return group.id;
    });

    return new Promise(resolve => {
      newObject.email.forEach(address => {
        commit('setUpdating', true);
        const invite = new Invite();
        invite.email = address;
        invite.message = newObject.message;
        invite.role = newObject.role;
        invite.sentAt = null;
        invite.groups_collection = groups;

        api.create(`/${domain}/invites`, Invite, invite).then(response => {
          dispatch(
            'normalize',
            {
              model: Invite,
              data: response.data.data
            },
            { root: true }
          );
          commit('setUpdating', false);
          resolve();
        });
      });
    });
  },

  remove({ commit }, collection) {
    return new Promise(resolve => {
      collection.forEach(invite => {
        commit('setDeleting', true);
        api.remove(Invite, invite).then(() => {
          Invite.delete(invite.id);
          commit('setDeleting', false);
          resolve();
        });
      });
    });
  },

  resend({ commit }, collection) {
    return new Promise(resolve => {
      collection.forEach(invite => {
        commit('setUpdating', true);
        api.resend(Invite, invite).then(() => {
          invite.state = 'sent';
          invite.sentAt = moment();
          commit('setUpdating', false);
          resolve();
        });
      });
    });
  },

  accept({ commit }, invite) {
    const domain = Context.query().first().domain;

    return new Promise(resolve => {
      commit('setUpdating', true);
      api
        .post(
          `/${domain}/invites/${invite.id}/actions/accept?token=${invite.token}`
        )
        .then(response => {
          authenticator.set(response.data.access_token);
          commit('setUpdating', false);
          resolve();
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
